import { GET_REQUESTS } from "./requests.constants";

export const getRequets = (payload, callback) => ({type: GET_REQUESTS, payload, callback})